import { render } from "./InventarioGlobal.vue?vue&type=template&id=cb1faa9a&scoped=true"
import script from "./InventarioGlobal.vue?vue&type=script&lang=js"
export * from "./InventarioGlobal.vue?vue&type=script&lang=js"

import "./InventarioGlobal.vue?vue&type=style&index=0&id=cb1faa9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb1faa9a"]])

export default __exports__